// Paypal sandbox api (https://developer.paypal.com/docs/api/overview/)
// replace empty string with your 'Client ID' and 'Secret'
export default {
  username: '',
  password: ''
}
